import { accountPermissions } from 'constants/common'

export const OPEN_BANKING_REGION = {
  AU: 'AU',
  OTHER: 'OTHER',
} as const

export type OpenBankingRegion =
  (typeof OPEN_BANKING_REGION)[keyof typeof OPEN_BANKING_REGION]

export type Pocket = {
  id: string
  name: string
  currency: string
  type: 'SAVINGS' | 'CURRENT' | 'CREDIT'
  address: string
  balance: number
  state: 'ACTIVE' | 'INACTIVE'
}

export type AccessToken = string

export type PushNotificationToken = {
  tokenId: string
  expiresIn: number
}

export type Error = {
  message: string
  description?: string
}

export type Rate = {
  fee: {
    amount: number
    currency: string
  }
  from: {
    amount: number
    currency: string
  }
  fromWithFee: {
    amount: number
    currency: string
  }
  rate: number
  rateInverted: number
  to: {
    amount: number
    currency: string
  }
  toWithFee: {
    amount: number
    currency: string
  }
}

export type AccountsConsent = {
  pockets: string[]
  permissions: (keyof typeof accountPermissions)[]
  expiryDate?: string
}

export type FundsConfirmationConsent = {
  pocketId: string
  expiryDate?: string
}

type Creditor = {
  accountNumber?: string
  sortCode?: string
  iban?: string
}

export enum ApmProvider {
  IDEAL = 'IDEAL',
}

type Apm = {
  provider: ApmProvider
  description: string
}

export type PaymentConsent = {
  client_name: string
  currencyOfTransfer?: string
  pocketId?: string
  currency: string
  amount?: string
  amountValue: number
  creditor: Creditor
  merchant: string
  frequency?: string
  firstPaymentDateTime?: number
  requestedExecutionDateTime?: number
  numberOfPayees?: number
  apm?: Apm
}

export type CurrencyInfo = {
  currency: string
  symbol: string
  code: string
  fraction: number
  country: string
}

export type CountryInfo = {
  country: string
  countryCode: string
  currencyCode: string
  phoneCode: string
}
